import {Fragment as _Fragment, jsx as _jsx, jsxs as _jsxs} from "react/jsx-runtime";
export let lastModified = undefined;
export let frontmatter = {
  "title": "query",
  "description": "`turbo query` 命令的 API 参考"
};
export let structuredData = {
  "contents": [{
    "heading": "",
    "content": "针对你的 monorepo 运行 GraphQL 查询。"
  }, {
    "heading": "",
    "content": "¥Run GraphQL queries against your monorepo."
  }, {
    "heading": "",
    "content": "未传递任何参数时，该命令将打开 GraphiQL 测试环境来运行查询。"
  }, {
    "heading": "",
    "content": "¥When no arguments are passed, the command will open a GraphiQL playground to run queries."
  }, {
    "heading": "",
    "content": "传递查询字符串时，该命令将运行查询并输出结果。"
  }, {
    "heading": "",
    "content": "¥When passed a query string, the command will run the query and output the results."
  }, {
    "heading": "",
    "content": "传递文件路径时，该命令将读取文件并运行查询。"
  }, {
    "heading": "",
    "content": "¥When passed a file path, the command will read the file and run the query."
  }],
  "headings": []
};
import {ExperimentalBadge} from '#components/experimental-badge';
export const toc = [];
function _createMdxContent(props) {
  const _components = {
    code: "code",
    p: "p",
    pre: "pre",
    span: "span",
    ...props.components
  };
  return _jsxs(_Fragment, {
    children: [_jsx(ExperimentalBadge, {}), "\n", _jsx(_components.p, {
      children: "针对你的 monorepo 运行 GraphQL 查询。"
    }), "\n", _jsx(_components.p, {
      children: "¥Run GraphQL queries against your monorepo."
    }), "\n", _jsx(_Fragment, {
      children: _jsx(_components.pre, {
        className: "shiki shiki-themes css-variables css-variables",
        style: {
          "--shiki-light": "var(--shiki-foreground)",
          "--shiki-dark": "var(--shiki-foreground)",
          "--shiki-light-bg": "var(--shiki-background)",
          "--shiki-dark-bg": "var(--shiki-background)"
        },
        tabIndex: "0",
        title: "Terminal",
        icon: "<svg viewBox=\"0 0 24 24\"><path d=\"m 4,4 a 1,1 0 0 0 -0.7070312,0.2929687 1,1 0 0 0 0,1.4140625 L 8.5859375,11 3.2929688,16.292969 a 1,1 0 0 0 0,1.414062 1,1 0 0 0 1.4140624,0 l 5.9999998,-6 a 1.0001,1.0001 0 0 0 0,-1.414062 L 4.7070312,4.2929687 A 1,1 0 0 0 4,4 Z m 8,14 a 1,1 0 0 0 -1,1 1,1 0 0 0 1,1 h 8 a 1,1 0 0 0 1,-1 1,1 0 0 0 -1,-1 z\" fill=\"currentColor\" /></svg>",
        children: _jsx(_components.code, {
          children: _jsxs(_components.span, {
            className: "line",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-function)",
                "--shiki-dark": "var(--shiki-token-function)"
              },
              children: "turbo"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-string)",
                "--shiki-dark": "var(--shiki-token-string)"
              },
              children: " query"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: " [query] [flags]"
            })]
          })
        })
      })
    }), "\n", _jsx(_components.p, {
      children: "未传递任何参数时，该命令将打开 GraphiQL 测试环境来运行查询。"
    }), "\n", _jsx(_components.p, {
      children: "¥When no arguments are passed, the command will open a GraphiQL playground to run queries."
    }), "\n", _jsx(_Fragment, {
      children: _jsx(_components.pre, {
        className: "shiki shiki-themes css-variables css-variables",
        style: {
          "--shiki-light": "var(--shiki-foreground)",
          "--shiki-dark": "var(--shiki-foreground)",
          "--shiki-light-bg": "var(--shiki-background)",
          "--shiki-dark-bg": "var(--shiki-background)"
        },
        tabIndex: "0",
        title: "Terminal",
        icon: "<svg viewBox=\"0 0 24 24\"><path d=\"m 4,4 a 1,1 0 0 0 -0.7070312,0.2929687 1,1 0 0 0 0,1.4140625 L 8.5859375,11 3.2929688,16.292969 a 1,1 0 0 0 0,1.414062 1,1 0 0 0 1.4140624,0 l 5.9999998,-6 a 1.0001,1.0001 0 0 0 0,-1.414062 L 4.7070312,4.2929687 A 1,1 0 0 0 4,4 Z m 8,14 a 1,1 0 0 0 -1,1 1,1 0 0 0 1,1 h 8 a 1,1 0 0 0 1,-1 1,1 0 0 0 -1,-1 z\" fill=\"currentColor\" /></svg>",
        children: _jsx(_components.code, {
          children: _jsxs(_components.span, {
            className: "line",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-function)",
                "--shiki-dark": "var(--shiki-token-function)"
              },
              children: "turbo"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-string)",
                "--shiki-dark": "var(--shiki-token-string)"
              },
              children: " query"
            })]
          })
        })
      })
    }), "\n", _jsx(_components.p, {
      children: "传递查询字符串时，该命令将运行查询并输出结果。"
    }), "\n", _jsx(_components.p, {
      children: "¥When passed a query string, the command will run the query and output the results."
    }), "\n", _jsx(_Fragment, {
      children: _jsx(_components.pre, {
        className: "shiki shiki-themes css-variables css-variables",
        style: {
          "--shiki-light": "var(--shiki-foreground)",
          "--shiki-dark": "var(--shiki-foreground)",
          "--shiki-light-bg": "var(--shiki-background)",
          "--shiki-dark-bg": "var(--shiki-background)"
        },
        tabIndex: "0",
        title: "Terminal",
        icon: "<svg viewBox=\"0 0 24 24\"><path d=\"m 4,4 a 1,1 0 0 0 -0.7070312,0.2929687 1,1 0 0 0 0,1.4140625 L 8.5859375,11 3.2929688,16.292969 a 1,1 0 0 0 0,1.414062 1,1 0 0 0 1.4140624,0 l 5.9999998,-6 a 1.0001,1.0001 0 0 0 0,-1.414062 L 4.7070312,4.2929687 A 1,1 0 0 0 4,4 Z m 8,14 a 1,1 0 0 0 -1,1 1,1 0 0 0 1,1 h 8 a 1,1 0 0 0 1,-1 1,1 0 0 0 -1,-1 z\" fill=\"currentColor\" /></svg>",
        children: _jsx(_components.code, {
          children: _jsxs(_components.span, {
            className: "line",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-function)",
                "--shiki-dark": "var(--shiki-token-function)"
              },
              children: "turbo"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-string)",
                "--shiki-dark": "var(--shiki-token-string)"
              },
              children: " query"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-string-expression)",
                "--shiki-dark": "var(--shiki-token-string-expression)"
              },
              children: " \"query { packages { items { name } } }\""
            })]
          })
        })
      })
    }), "\n", _jsx(_components.p, {
      children: "传递文件路径时，该命令将读取文件并运行查询。"
    }), "\n", _jsx(_components.p, {
      children: "¥When passed a file path, the command will read the file and run the query."
    }), "\n", _jsx(_Fragment, {
      children: _jsx(_components.pre, {
        className: "shiki shiki-themes css-variables css-variables",
        style: {
          "--shiki-light": "var(--shiki-foreground)",
          "--shiki-dark": "var(--shiki-foreground)",
          "--shiki-light-bg": "var(--shiki-background)",
          "--shiki-dark-bg": "var(--shiki-background)"
        },
        tabIndex: "0",
        title: "Terminal",
        icon: "<svg viewBox=\"0 0 24 24\"><path d=\"m 4,4 a 1,1 0 0 0 -0.7070312,0.2929687 1,1 0 0 0 0,1.4140625 L 8.5859375,11 3.2929688,16.292969 a 1,1 0 0 0 0,1.414062 1,1 0 0 0 1.4140624,0 l 5.9999998,-6 a 1.0001,1.0001 0 0 0 0,-1.414062 L 4.7070312,4.2929687 A 1,1 0 0 0 4,4 Z m 8,14 a 1,1 0 0 0 -1,1 1,1 0 0 0 1,1 h 8 a 1,1 0 0 0 1,-1 1,1 0 0 0 -1,-1 z\" fill=\"currentColor\" /></svg>",
        children: _jsx(_components.code, {
          children: _jsxs(_components.span, {
            className: "line",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-function)",
                "--shiki-dark": "var(--shiki-token-function)"
              },
              children: "turbo"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-string)",
                "--shiki-dark": "var(--shiki-token-string)"
              },
              children: " query"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-string)",
                "--shiki-dark": "var(--shiki-token-string)"
              },
              children: " query.gql"
            })]
          })
        })
      })
    })]
  });
}
export default function MDXContent(props = {}) {
  const {wrapper: MDXLayout} = props.components || ({});
  return MDXLayout ? _jsx(MDXLayout, {
    ...props,
    children: _jsx(_createMdxContent, {
      ...props
    })
  }) : _createMdxContent(props);
}
